import React from 'react';
import classNames from 'classnames';

import Icon from 'src/components/Common/Icon';

/** Type of the props from a ListItem. */
interface ListItemProps {
  /** Content that should be displayed as a ListItem. */
  children: React.ReactNode;
  /** CSS class name */
  className?: string;
  /** Icon Displayed in front of the children of the ListItem. */
  icon?: string;
}

/** Displays a ListItem by default with a dot in front of it. */
const ListItem = ({ children, className, icon }: ListItemProps) => {
  return (
    <li className={classNames(className, 'flex items-baseline')}>
      {icon && <Icon name={icon} />}
      <p className="mb-0 ml-2">{children}</p>
    </li>
  );
};

ListItem.defaultProps = {
  className: null,
  icon: null,
};

export default ListItem;
